export default __webpack_public_path__ + "static/media/greenchillipowder.b117926b.jpeg";